import { Box, LinearProgress, Typography } from '@mui/material';
import { UploadProgressState } from '../../types';

interface UploadProgressProps {
  progress: UploadProgressState;
}

const formatBytes = (bytes: number): string => {
  const value = Math.max(bytes, 0);
  if (value < 1024) {
    return `${Math.round(value)} B`;
  }
  if (value < 1024 * 1024) {
    return `${(value / 1024).toFixed(1)} KB`;
  }
  return `${(value / (1024 * 1024)).toFixed(2)} MB`;
};

const UploadProgress: React.FC<UploadProgressProps> = ({ progress }) => {
  const percentage = Math.round(Math.min(Math.max(progress.percentage, 0), 100));
  const hasByteTotal = progress.totalBytes > 0;
  const processedBytes = hasByteTotal
    ? Math.min(Math.max(progress.processedBytes, 0), progress.totalBytes)
    : 0;
  const label = hasByteTotal
    ? `${percentage}%　${formatBytes(processedBytes)} / ${formatBytes(progress.totalBytes)}`
    : `${percentage}%`;

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <LinearProgress variant="determinate" value={percentage} />
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default UploadProgress;
